import { ENVIRONMENT_CONSTANTS } from "@/constants/environment.constants";

export function isDev() {
  return getEnv() === ENVIRONMENT_CONSTANTS.DEVELOPMENT;
}

export function getEnv() {
  return import.meta.env.MODE as ENVIRONMENT_CONSTANTS;
}
